{
	"units": {
        "header": "Alle Händler ({{count}})",
        "details": "Händler Details",
        "days": "in tagen",
        "configEKPriceChangeDays": "Zeitraum EK-Änderungen",
        "configProductCreationDays": "Zeitraum Markierung neue Artikel",
        "enabled": "Aktiv",
        "disabled": "Deaktiviert",
        "editSuccess": "Händler {{unitName}} wurde erfolgreich aktualisiert.",
        "buttons": {
            "edit": "Ändern",
            "cancel": "Abbrechen",
            "save": "Speichern"
        }
    },
    "unitsBreadcrumbs": {
        "list": "Händler Übersicht"
    }
}